/**
 * Press.tsx — Catch The Pattern™ Pro press page
 * Route: /press
 * Global rule: every wrapper gets a press page. All link back to ellari.dev/press.
 */

const FACTS = [
  ["Live", "logic.naci.tech"],
  ["Entity", "Ellari Ventures LLC (TX)"],
  ["Founded", "2026"],
  ["Category", "AI-powered cognitive training / SaaS"],
  ["Pricing", "Free · Pro $12/month · Scholar $29/month"],
  ["Engine", "EMET Engine — Cloudflare Workers + Claude API"],
  ["Modes", "Solo · Challenge · Sparring · Import · Roots ℵ"],
  ["Contact", "hello@ellari.dev"],
];

export default function Press() {
  return (
    <div style={{ minHeight:"100vh", background:"#faf8f4", color:"#1a1a1a", fontFamily:"Georgia,'Times New Roman',serif" }}>
      <style>{`
        * { box-sizing:border-box; margin:0; padding:0; }
        .mono { font-family:'Courier New',monospace; }
        .rule { height:1px; background:#d8d0c8; width:100%; }
        a { color:#1a1a1a; }
        a:hover { opacity:.65; }
      `}</style>

      {/* Nav */}
      <nav style={{ borderBottom:"1px solid #d8d0c8", padding:"0 48px", height:52, display:"flex", alignItems:"center", justifyContent:"space-between", background:"#fff" }}>
        <div style={{ display:"flex", alignItems:"baseline", gap:10 }}>
          <a href="/" style={{ fontSize:16, textDecoration:"none" }}>Catch The Pattern™</a>
          <span className="mono" style={{ fontSize:10, color:"#8a8070", letterSpacing:".1em" }}>PRESS</span>
        </div>
        <div style={{ display:"flex", gap:24 }}>
          <a href="/" className="mono" style={{ fontSize:11, color:"#8a8070", textDecoration:"none" }}>← Product</a>
          <a href="https://ellari.dev/press" className="mono" style={{ fontSize:11, color:"#8a8070", textDecoration:"none" }}>Ellari Ventures →</a>
        </div>
      </nav>

      <div style={{ maxWidth:820, margin:"0 auto", padding:"72px 48px" }}>

        {/* Header */}
        <p className="mono" style={{ fontSize:10, color:"#8a8070", letterSpacing:".14em", marginBottom:16 }}>PRESS ROOM · LOGIC RIGOR</p>
        <h1 style={{ fontSize:"clamp(28px,4vw,42px)", fontWeight:400, lineHeight:1.2, marginBottom:20 }}>
          Catch The Pattern™ — AI-powered logic training for people who work with language under pressure.
        </h1>
        <div className="rule" style={{ marginBottom:48 }} />

        {/* Product blurb */}
        <section style={{ marginBottom:48 }}>
          <p className="mono" style={{ fontSize:10, color:"#8a8070", letterSpacing:".12em", marginBottom:16 }}>PRODUCT</p>
          <p style={{ fontSize:17, lineHeight:1.8, color:"#3a3228", maxWidth:620 }}>
            Catch The Pattern™ is an AI-powered training game that analyzes sentences for logical structure — identifying fallacies, presuppositions, and formal inference patterns across seven analysis steps. Five training modes. Six difficulty levels. A Hebrew morphology module (Roots ℵ) that maps trilateral roots to formal logic primitives and IP naming candidates. Built on Cloudflare Workers and Claude API. Deployed at logic.naci.tech.
          </p>
        </section>

        {/* Key facts */}
        <section style={{ marginBottom:48 }}>
          <p className="mono" style={{ fontSize:10, color:"#8a8070", letterSpacing:".12em", marginBottom:16 }}>KEY FACTS</p>
          <div style={{ border:"1px solid #d8d0c8" }}>
            {FACTS.map(([k, v], i) => (
              <div key={k} style={{ display:"flex", gap:0, borderBottom: i < FACTS.length-1 ? "1px solid #ece8e0" : "none" }}>
                <div className="mono" style={{ fontSize:11, color:"#8a8070", letterSpacing:".06em", padding:"12px 20px", minWidth:160, borderRight:"1px solid #ece8e0", background:"#fdf9f5" }}>{k.toUpperCase()}</div>
                <div style={{ fontSize:14, padding:"12px 20px", color:"#3a3228" }}>{v}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Founder */}
        <section style={{ marginBottom:48 }}>
          <p className="mono" style={{ fontSize:10, color:"#8a8070", letterSpacing:".12em", marginBottom:16 }}>FOUNDER</p>
          <p style={{ fontSize:16, lineHeight:1.8, color:"#3a3228", maxWidth:620 }}>
            <strong>Ellari Sigler</strong> (also operating as Naci Sigler) is a Texas-based technologist, published author (30+ books), spoken word artist, and multi-domain operator. She is the founder of Ellari Ventures LLC, operator of four licensed childcare facilities across Northeast Texas under Sigwell and Siggco Inc., and the architect of the ELEOS cognitive operating system. Catch The Pattern™ was built from lived experience in regulatory defense.
          </p>
          <p style={{ fontSize:14, color:"#8a8070", marginTop:12 }}>
            <a href="https://ellari.dev">ellari.dev</a> · <a href="https://nacisigler.com">nacisigler.com</a>
          </p>
        </section>

        {/* Quote */}
        <section style={{ marginBottom:48, borderLeft:"3px solid #d8d0c8", paddingLeft:24 }}>
          <p style={{ fontSize:20, fontStyle:"italic", lineHeight:1.65, color:"#3a3228", maxWidth:580 }}>
            "Most people sense when a sentence is wrong. Catch The Pattern™ names what they sense — and trains them to find it faster. The pattern has a name. Learn it."
          </p>
          <p className="mono" style={{ fontSize:11, color:"#8a8070", marginTop:12, letterSpacing:".06em" }}>— ELLARI SIGLER, FOUNDER</p>
        </section>

        {/* Wrapper family */}
        <section style={{ marginBottom:48 }}>
          <p className="mono" style={{ fontSize:10, color:"#8a8070", letterSpacing:".12em", marginBottom:16 }}>PRODUCT FAMILY</p>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:1, background:"#d8d0c8" }}>
            {[
              ["Catch The Pattern™ Pro", "logic.naci.tech", "General knowledge training · $12/month"],
              ["Inspection Defense", "logic.naci.tech/inspection-defense", "Regulatory operator training · $197/year"],
              ["Mirror Bloom Logic", "logic.naci.tech/mirror-bloom", "Personal development · $47 challenge"],
              ["Naming Roots Lab", "logic.naci.tech/naming-roots", "IP naming research · $197/month"],
            ].map(([name, url, desc]) => (
              <div key={name} style={{ background:"#fdf9f5", padding:"16px 20px" }}>
                <div style={{ fontSize:15, marginBottom:4 }}>{name}</div>
                <div className="mono" style={{ fontSize:10, color:"#8a8070", marginBottom:6 }}>{url}</div>
                <div style={{ fontSize:13, color:"#6a6258" }}>{desc}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Coverage */}
        <section style={{ marginBottom:48 }}>
          <p className="mono" style={{ fontSize:10, color:"#8a8070", letterSpacing:".12em", marginBottom:16 }}>COVERAGE</p>
          <p style={{ fontSize:14, color:"#8a8070", fontStyle:"italic" }}>No coverage yet. Be the first.</p>
        </section>

        {/* Press contact */}
        <section style={{ marginBottom:48, background:"#fff", border:"1px solid #d8d0c8", padding:"24px 28px" }}>
          <p className="mono" style={{ fontSize:10, color:"#8a8070", letterSpacing:".12em", marginBottom:12 }}>PRESS CONTACT</p>
          <p style={{ fontSize:15, marginBottom:4 }}>Ellari Sigler · Founder, Ellari Ventures LLC</p>
          <p style={{ fontSize:15 }}><a href="mailto:hello@ellari.dev">hello@ellari.dev</a></p>
          <p className="mono" style={{ fontSize:11, color:"#8a8070", marginTop:8 }}>Response within 48 hours · Interview requests welcome</p>
        </section>

        {/* Back-link */}
        <div className="rule" style={{ marginBottom:24 }} />
        <p style={{ fontSize:13, color:"#8a8070" }}>
          Part of the <a href="https://ellari.dev">Ellari Ventures LLC</a> product family. ·{" "}
          <a href="https://ellari.dev/press">Ellari Ventures Press Room →</a>
        </p>
      </div>
    </div>
  );
}
